import { render, staticRenderFns } from "./foa.vue?vue&type=template&id=3db818ee&"
import script from "./foa.vue?vue&type=script&lang=js&"
export * from "./foa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports